












import Vue from 'vue';
import {
  Component,
  Prop,
} from 'vue-property-decorator';
import FormFactory from '@/components/FormBuilder/FormFactory.vue';
import {
  Action,
  State,
} from 'vuex-class';

@Component({
  components: {
    FormFactory,
  },
})
export default class FormFactoryModal extends Vue {
  @Prop({
    type: Boolean,
    default: false,
  }) readonly isShown!: boolean

  @State('isModalVisible', { namespace: 'entity' })
  readonly isModalVisible!: boolean;

  @Action('toggleEntityModal', { namespace: 'entity' })
  toggleEntityModal: any;

  onClose() {
    this.toggleEntityModal(false);
  }
}

